import { render } from "./SidebarMoreModules.vue?vue&type=template&id=486f7bc6"
import script from "./SidebarMoreModules.vue?vue&type=script&lang=js"
export * from "./SidebarMoreModules.vue?vue&type=script&lang=js"

import "./SidebarMoreModules.vue?vue&type=style&index=0&id=486f7bc6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__